import {Firebase, db, assetMediaStorageRef, assetModelStorageRef, assetAudioStorageRef} from '../../firebaseDB'
import {effects} from '../../views/assets/effects' 
const actions = {
    async getAsset({state},payload){
        let { ref }  = payload
        try {
            const res = await (await db.ref(ref).once('value')).val()
            if(res) return res
            return null
        } catch (error) {
            console.log(error);
        }
    },

    async create({state,commit,dispatch,getters ,rootState},payload) {
        let imageSaved=true;
        let bundleSaved=true;
        let fbxSaved=true;
        let soundSaved=true;
        let videoSaved=true;
        let glbSaved=true;
        const { data, asset_type} = payload
        const currentDate = new Date()
        const datetime = currentDate.getDate() + '/' +(currentDate.getMonth() + 1) + '/' +currentDate.getFullYear() + ' @ ' +currentDate.getHours() + ':' +currentDate.getMinutes() + ':' +currentDate.getSeconds()
        data.meta_data = {}
        data.meta_data.creator = rootState.user.email
        data.meta_data.date_uploaded = datetime
        if(!data.id){
            data.id = db.ref(`asset_data/${asset_type}/`).push().key;
            data.meta_data.date_uploaded = datetime
            data.meta_data.creator = rootState.user.email
            
        }
        data.meta_data.date_modified = datetime
        //assets files refs <---work--->
        if(data.image) {
            imageSaved = false;
            const imageRef = `${data.id}.jpg`
           let res = await  dispatch('uplaodfile',{ type : 'image', ref : imageRef, data : data})
                if(res) {imageSaved=true; data.image.imageURL = res} 
        }
        if(data.fbx) {
            
            fbxSaved = false;
            const fbxRef = `${data.id}/original.fbx`
            const res = await dispatch('uplaodfile',{ type : 'fbx', ref : fbxRef, data : data})
            if(res) {fbxSaved=true; data.fbx.fileURL =res}
        }
        if(data.glb) {
            glbSaved = false;
            let type = data.glb.file['name'].split('.').pop()
            const glbRef = `${data.id}/original.${type}`
            const res = await dispatch('uplaodfile',{ type : 'glb', ref : glbRef, data : data})
            if(res) {glbSaved=true; data.glb.fileURL =res}
        }
        if(data.audio) {
            soundSaved = false;
            const soundRef = `${data.id}.mp3`
            const res = await dispatch('uplaodfile',{ type : 'audio', ref : soundRef, data : data})
            if(res) {soundSaved=true; data.audio.audioURL = res}
        }
        if(data.video) {
            videoSaved = false;
            const videoRef = `${data.id}.mp4`
            const res = await dispatch('uplaodfile',{ type : 'video', ref : videoRef, data : data})
            if(res) {videoSaved=true; data.video.videoURL =res}
        }
        
        if(data.asset_bundle) { 
            bundleSaved = false
            const bundle_types = Object.getOwnPropertyNames(data.asset_bundle)
            let res = null;
            if(bundle_types.includes('__ob__')) bundle_types.splice(bundle_types.indexOf('__ob__'),1)
            if(bundle_types.length > 0 ) {
                // console.log("asset_bundle",bundle_types )
                for (const type of bundle_types) {
                    const fileRef = `${data.id}/${type}`
                    res = await dispatch('uplaodfile',{ type : 'asset_bundle', ref : fileRef, data : data, bundle : type })
                    if(res) data.asset_bundle[type].fileURL =res
                    console.log("bundle res",res);
                }
                if(res) bundleSaved=true;
            } 
        }
        // console.log("imageSaved",imageSaved);
        // console.log("bundleSaved",bundleSaved);
        // console.log("fbxSaved",fbxSaved);
        // console.log("videoSaved",videoSaved);
        // console.log("soundSaved",soundSaved);
        if(imageSaved && bundleSaved && fbxSaved && videoSaved && soundSaved){
            console.log("form data",data)
            db.ref(`assets/asset_data/${asset_type}/${data.id}`).set({...data})
            return true;
        }

    }, 
    async uplaodfile( { state }, { type, ref, data, bundle }){
        let file = null;
        let dbRef = null
        console.log("file type",type);
        if( type == 'image' ) {file = data[type]['imageFile']; dbRef =assetMediaStorageRef }
        else if (['fbx','glb','gltf'].includes(type)) {file = data[type]['file']; dbRef = assetModelStorageRef}
        else if (type == "audio") {file = data[type]['audioFile']; dbRef = assetAudioStorageRef }
        else if (type == "video") {file = data[type]['videoFile']; dbRef = assetMediaStorageRef}
        else {file = data[type][bundle]['file'] ; dbRef = assetModelStorageRef}
        if(file && dbRef ) {
          const res = await  dbRef.child(ref).put(file)
            return res.ref.getDownloadURL();
        }
  
    },
    async delete({state},payload){
        const { asset_type,type} = payload;
        if (type == 'single') {
            const { item} = payload;
            const res  = await db.ref(`assets/asset_data/${asset_type}/${item.id}`).remove();
        }
        else {
            const { items} = payload;
            for (let index = 0; index < items.length; index++) {
                const elementId = items[index];
                const res  = await db.ref(`assets/asset_data/${asset_type}/${elementId}`).remove();
            }
            
        }
        return true
 
    },
    async uploadMulti({state,dispatch},payload){
        if(payload) {
            let {images, data, ref} = payload;
            for (let index = 0; index < data.length; index++) {
                const item = data[index];
                item.image = images.find(img => img.fileName = item.image)
                const res =  await dispatch('create',{data:item,asset_type:ref})
                if (res) {
                    console.log(animation,'----> done',index)
                }
                if(item.id) {
                    console.log('has id ');
                    delete item.id
                }
                
            }
        }

    }
    
    // async AddEffects({state,dispatch}){
    //     console.log("state",state);
    //     let form = {
    //         blend: "",
    //         category: "In Movement",
    //         duration: 0,
    //         genre: "",
    //         inverseKinematics: "",
    //         joint: 0,
    //         name: "Rejected",
    //         numberOfLoops: 0,
    //         rig: "Humanoid",
    //         rotationOfOrigin: {
    //             X: 0,
    //             Y: 0,
    //             Z: 0
    //         },
    //         rotations: "Inwards",
    //         spectrum: "Energy",
    //         stich: "",
    //         trim: "",
    //         typeOfAnimation: "In Movement",
    //     }
    //     if(state.effectImageObject && animations) {
    //         form.image = state.effectImageObject
    //         for (let index = 0; index < animations.length; index++) {
    //             const animation = animations[index];
    //             form.name = animation
    //             const res =  await dispatch('create',{data:form,asset_type:'animation'})
    //            if (res) {
    //                console.log(animation,'----> done',index)
    //            }
    //            if(form.id) {
    //                console.log('has id ');
    //                delete form.id
    //             }
                
    //         }

    //     }

    // },
    // async getEffects({state}){
    //     const res = await db.ref('assets/asset_data/effect').once('value')
    //     if(res) {
    //         state.effects = res.val()
    //         console.log("effect res",state.effects);
    //         state.effects = Object.keys(state.effects).map(key => {
    //              state.effects[key].prefabName =  state.effects[key].name
    //              state.effects[key].id =  key
    //              return state.effects[key]
    //         })
    //     }

    // },
    // async updateEffects({state,dispatch}){
    //     console.log("state",state);
    //     if(state.effects && state.effects.length > 0) {
    //         for (let index = 0; index <  state.effects.length; index++) {
    //             let effect = state.effects[index];
    //             if(effects.includes(effect.name)) {
    //                 effect.image = state.effectImageObject
    //                 const res =  await dispatch('create',{data:effect,asset_type:'effect'})
    //                 if (res) {
    //                     console.log("insode",effect,effect.id);
    //                     console.log(effect.name,'----> done',index)
    //                 }
    //                 //    if(form.id) {
    //                     //        console.log('has id ');
    //                     //        delete form.id
    //                     //     }
    //                 }
                    
    //             }
                
    //         }
    //         console.log("state",state.effects);

    // },


}

export default actions;


// WEBPACK FOOTER //
// ./src/store/assets/actions.js